/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteVoxtralCorrectionContextRequest } from '../../models/delete-voxtral-correction-context-request';

export interface ApiBroadcastVoxtralCorrectionContextsNameDelete$Params {
  name: string;
      body?: DeleteVoxtralCorrectionContextRequest
}

export function apiBroadcastVoxtralCorrectionContextsNameDelete(http: HttpClient, rootUrl: string, params: ApiBroadcastVoxtralCorrectionContextsNameDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastVoxtralCorrectionContextsNameDelete.PATH, 'delete');
  if (params) {
    rb.path('name', params.name, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastVoxtralCorrectionContextsNameDelete.PATH = '/api/Broadcast/voxtral/correction-contexts/{name}';
